import React from 'react';

import styles from './MobileMenu.module.scss';

const Separator = () => <div className={styles.separator} />;

export default Separator;
